<template>
  <div id="app">
    <component :is="loadingComponent"></component>
  </div>
</template>

<script>

import LayoutAccount from "@/layouts/account/layout.vue";
import LayoutDefault from "@/layouts/default/layout.vue";
import LayoutErrors from "@/layouts/errors/layout.vue";

export default {
  components: {
    LayoutAccount,
    LayoutDefault,
    LayoutErrors
  }, 
  computed: {
    loadingComponent() {
      if (this.$route.name == 'errors/404')
        return 'layout-errors';
      else if (this.$route.path.startsWith('/account'))
        return 'layout-account';
      else
        return 'layout-default';
    }
  },
  watch: {
    $route (to, from){
        $('body').removeClass('mobile-nav-on')
    }
  } 
}
</script>